import { createAction } from '@reduxjs/toolkit';

export const clearMeetingsAction = createAction('calendar/clearMeetings');
export const clearTimeSlotsAction = createAction('calendar/clearTimeSlots');
